import { ProductsPage } from "./products.component";
import { connect } from "react-redux";
import { addToCart } from "./../../api/cart/cartAction";
import { addToWishlist, removeToWishlist } from "./../../api/product/productAction";

const mapDispatchToProps = {
  addToCart,
  addToWishlist,
  removeToWishlist,
};

const mapStateToProps = (state) => ({
  isLoading: state.productPage.isLoading,
  isLoggedIn: state.userPage.isLoggedIn,
});

export const ProductsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductsPage);
